<template>
	<RouterLink class="activity-map-button" :to="to" :aria-label="t('activityPage.details.viewOnMap')">
		<span class="map-icon" aria-hidden="true"></span>
	</RouterLink>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n"
import type { RouteLocationRaw } from "vue-router"

defineProps<{
	to: RouteLocationRaw
}>()

const { t } = useI18n()
</script>

<style scoped>
.activity-map-button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: var(--size-button-lg);
	height: var(--size-button-lg);
	border: var(--border-width-thin) solid var(--neutral-200);
	border-radius: var(--border-radius-md);
	color: var(--neutral-600);
	flex: 0 0 auto;

	&:hover {
		border-color: var(--neutral-400);
		color: var(--neutral-900);
	}

	&:focus-visible {
		outline: 2px solid var(--primary-green);
		outline-offset: 2px;
	}

	.map-icon {
		display: inline-block;
		width: var(--size-icon-lg);
		height: var(--size-icon-lg);
		background: currentColor;
		mask: url("/icons/activity-map.svg") center / contain no-repeat;
	}
}
</style>
